/* eslint-disable quotes */
import type { Color, ColorContrast, ColorSchema, Theme } from "themes/interfaces";
import { BaseBorder, BaseColor, BaseComponent, BaseFont, BaseSpacing } from "themes/base";
import { Enums } from "utils";

export const Light: Theme = {
  id: Enums.EnumTheme.Light,
  font: BaseFont,
  color: {
    ...BaseColor,
    theme: { color: "#E8E8E8" } as ColorSchema,
    border: { color: "#ACB8C2", accent: "#E8EEF3" } as ColorContrast,
    shadow: { color: "0 3px 10px 0 #D0D0D0" } as ColorContrast,
    overlay: { color: "rgba(0, 0, 0, 0.5)" } as ColorContrast,
    input: { color: "#FFFFFF", accent: "#DBDBDB" } as ColorSchema,
    font: { color: "#333333", accent: "#666666" } as ColorContrast,
    background: { color: "#FFFFFF", accent: "#F8F8F8" } as ColorSchema,
    primary: { color: "#fdebc9", accent: "#f8df9f", text: "#333333", textAccent: "#333333" } as ColorSchema,
    accent: { color: "#FFAC4B", text: "#FFFFFF" } as ColorSchema,
    secondary: { color: "#F8F8F8", text: "#333333" } as ColorSchema,
    disabled: { color: "#F8F8F8", text: "#A6A6A6" } as ColorSchema,
  } as Color,
  border: BaseBorder,
  spacing: BaseSpacing,
  component: BaseComponent,
};
